import OnboarderLayout from '@/modules/onboarder/layout/OnboarderLayout.vue';

const routes = [
  {
    path: 'on-boarder-workflow',
    name: 'on-boarder-workflow',
    component: () => import('@/modules/onboarder/views/Home.vue')
  },
  {
    path: 'application-pool',
    name: 'application-pool',
    component: () => import('@/modules/onboarder/views/ApplicationPool.vue')
  },
  {
    path: 'my-workload',
    name: 'my-workload',
    component: () => import('@/modules/onboarder/views/MyWorkload.vue')
  }
];

export default {
  path: 'on-boarder',
  name: 'on-boarder',
  component: OnboarderLayout,
  redirect: {
    name: 'on-boarder-workflow'
  },
  meta: {
    requiresAuth: true
  },
  children: [...routes]
};
